import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BasefieldV2Component } from '@app/formly/types/v2/basefield-v2/basefield-v2.component';
import { DropdownItem } from '@voyagu/radar-design-system';

@Component({
  selector: 'multi-select-field',
  templateUrl: './multi-select-field.component.html',
  styleUrls: ['./multi-select-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectFieldComponent extends BasefieldV2Component implements OnInit {
  items: DropdownItem[];
  initial: DropdownItem[];

  ngOnInit() {
    this.items = this.props.values?.map((v: FilterOption) => ({
      label: v.value,
      value: v.key,
      ...(v.picture != null ? { picture: v.picture } : {}),
    }));

    this.initial = this.items.filter((i) => this.props.initial?.includes(i.value));
  }

  select(selectedItems: DropdownItem[]) {
    this.formControl.setValue(selectedItems.map(({ value }) => value));
    this.formControl.markAsDirty();
  }
}

type FilterOption = {
  key: string;
  value: string;
  picture?: string | null;
};
